import React, { Component } from 'react';
import './emergencyLighting.less';
import { meshLog, SPGet, SPSet } from "../../../../utils/spUtils";
import PubSub from 'pubsub-js'
import { Switch } from 'antd';
import btn_on1 from "../../../../imgs/btn/btn_on.png";
import btn_off1 from "../../../../imgs/btn/btn_off.png";
import btn_on from "../../../../imgs/mesh/btn_on.png";
import btn_off from "../../../../imgs/mesh/btn_off.png";
import emergency from "../../../../imgs/item/emergency.png";
import light_normal3 from "../../../../imgs/mesh/light_normal3.png";
import devices from "../../../../imgs/item/devices.png";
import montion from "../../../../imgs/item/montion.png";
import btn_refresh from "../../../../imgs/btn/btn_refresh.png";
import arrow_right from "../../../../imgs/btn/arrow_right.png";
import arrow_down from "../../../../imgs/btn/arrow_down.png";
import eye_show from "../../../../imgs/btn/eye_show.png";
import wifi_4 from "../../../../imgs/mesh/wifi_4.png";
import wifi_0 from "../../../../imgs/mesh/wifi_0.png";
import { sendOpcode_identify, sendOpcode_devices_state, sendOpcode_group_onoff, sendOpcode_group_light } from '../../../../utils/opcodeUtils';
import { getDevicesByGroupId } from '../../../../utils/meshUtils';
import { SET_ControlPageDetailPage_DIALOG_HIDE } from "../../../../const/infoConst"
import { IsEmergencyDevice } from '../../../../utils/pidUtils';

import exit from "../../../../imgs/emergencyLighting/exit.png";
import green_exit from "../../../../imgs/emergencyLighting/green_exit.png";
import red_exit from "../../../../imgs/emergencyLighting/red_exit.png";
import green_off from "../../../../imgs/emergencyLighting/green_off.png";
import green_on from "../../../../imgs/emergencyLighting/green_on.png";
import red_on from "../../../../imgs/emergencyLighting/red_on.png";
import red_off from "../../../../imgs/emergencyLighting/red_off.png";

import mode_left from "../../../../imgs/emergencyLighting/mode_left.png";
import mode_right from "../../../../imgs/emergencyLighting/mode_right.png";

import mode_all from "../../../../imgs/emergencyLighting/mode_all.png";
import mode from "../../../../imgs/emergencyLighting/mode.png";

export default class EmergencyLighting extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOn: true,

            dimLevel: 50,
            groupInfo: '',

            checked: false, //group是否展开
            devices: [], //group数据

            monthlyTest: false,
            annualTest: false,
            greenIsOn: false,
            redIsOn: false,
            exitIsOn: 0,

        }
    }

    componentDidMount() {
        this.updateGroupUI();
        PubSub.subscribe('updateGroupdataUI', (msg, data) => {
            this.updateGroupUI();
        })

        meshLog('更新灯的状态',);
        PubSub.unsubscribe("mqttDeviceState")
        PubSub.subscribe('mqttDeviceState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
    }



    updateGroupUI() {
        const groupInfo = JSON.parse(SPGet("groupInfo"))
        this.setState({
            dimLevel: groupInfo.dimLevel,
            devices: getDevicesByGroupId(groupInfo.groupID), //group数据需要在加一层判断是不是应急设备，通过pid判断
        })
        //更新sensor界面的布局,要从数据库先判断有没有这个场景 查找4305的sceneMode，在找到对应的groupid 在看sceneValue（1 2 3 ）对应15 30  90 repeatMode代表周一 周二  repeatWeek代表隔几周

    }


    monthlyTestClick(key) {
        let diff = this.state.monthlyTest;
        this.setState({
            monthlyTest: !diff,
        })
        //执行方法
        sendOpcode_group_light(key, diff);
    };

    annualTestClick(key) {
        let diff = this.state.annualTest;
        this.setState({
            annualTest: !diff,
        })
        //执行方法  sendOpcode_group_onoff(key);
    };

    onoffClick(key) {
        let diff = this.state.isOn;
        this.setState({
            isOn: !diff,
        })
        sendOpcode_group_onoff(key);
    };

    colorChangeClick(key) {
        if (key == 'green') {
            // let diff = this.state.greenIsOn;
            this.setState({
                greenIsOn: true,
                redIsOn: false,
                exitIsOn: 1,
            })
        } else {
            // let diff = this.state.redIsOn;
            this.setState({
                redIsOn: true,
                greenIsOn: false,
                exitIsOn: 2,
            })
        }

    };

    //group下面跳转
    gotoEmergencyLightingDevice = () => {
        PubSub.publish('gotoEmergencyLightingDevice', '')//显示EmergencySetDevice界面
    }


    //灯identify
    showHightLight = (device) => {
        sendOpcode_identify(device);
    }


    controlPageDetailContainer = (device) => {
        SPSet('controlDevice', JSON.stringify(device))
        PubSub.publish(SET_ControlPageDetailPage_DIALOG_HIDE, device)//控制ControlPageDetailPage弹框显示
    }

    emergencyRefreshDevices = () => {
        //获取单灯的状态，通过网关来返回的
        sendOpcode_devices_state()
        meshLog('获取单灯的状态',);
    }


    render() {
        const { isOn, dimLevel, monthlyTest, annualTest, greenIsOn, redIsOn, exitIsOn } = this.state;

        return (
            <div className="emer-container">

                {/* 组名和电源按钮 */}
                <div className="group-header">
                    <div className="action-title">
                        <img src={light_normal3} />
                        <span>{this.state.groupInfo.name}</span>
                    </div>
                </div>
                {/* Dim Level */}
                <div className="dim-level">
                    <div className="label">Dim Level</div>
                    <div className="value-boxes">
                        <div className="box">{dimLevel}%</div>
                    </div>
                </div>
                {/* Dim滑动条 */}
                <input type="range"
                    min="0"
                    max="100"
                    value={dimLevel}
                    className="slider"
                    onMouseUp={(e) => this.handleMouseUp('dimLevel', parseInt(e.target.value))}
                    onChange={(e) => this.handleChange1('dimLevel', parseInt(e.target.value))} />
                {/* CCT Tunable */}

                <div className="exit-level">
                    <div className="label">EXIT Color Setup</div>
                </div>
                <div className="group-header" style={{ marginTop: 10 }}>
                    <img className="exit-icon" src={exitIsOn == 0 ? exit : exitIsOn == 1 ? green_exit : red_exit} />
                    <img className="onoff-icon" style={{ marginLeft: 125 }} src={greenIsOn ? green_on : green_off} onClick={() => this.colorChangeClick('green')} />
                    <img className="onoff-icon" src={redIsOn ? red_on : red_off} onClick={() => this.colorChangeClick('red')} />
                </div>

                <div className="exit-level">
                    <div className="label">EXIT Direction Setup</div>
                </div>
                <div className="group-header" style={{ marginTop: 10 }}>
                    <img className="exit-icon" src={exitIsOn == 0 ? exit : exitIsOn == 1 ? green_exit : red_exit ? exitIsOn : exitIsOn} />
                    <img className="onoff-icon" style={{ marginLeft: 125 }} src={mode_left} onClick={() => this.onoffClick('green')} />
                    <img className="onoff-icon" src={mode_right} onClick={() => this.onoffClick('red')} />
                </div>
                <div className="exit-level">
                    <div className="label">EXIT Color Setup</div>
                </div>
                <div className="group-header" style={{ marginTop: 10 }}>
                    <img className="mode-icon" src={mode_all} />
                    <img className="onoff-icon" src={mode} onClick={() => this.onoffClick('green')} />
                    <img className="onoff-icon" src={mode_left} onClick={() => this.onoffClick('green')} />
                    <img className="onoff-icon" src={mode_right} onClick={() => this.onoffClick('red')} />
                </div>


                <div className="line_space"></div>
                <div className="group-header">
                    <div className="action-title">
                        {/* <img className='icon' src={emergency} /> */}
                        <span>Manual Test</span>
                    </div>
                    <img className="onoff-icon" src={isOn ? btn_on : btn_off} onClick={() => this.onoffClick('EmergencyTest')} />
                </div>

                <div className="group-header">
                    <div className="action-title">
                        {/* <img className='icon' src={emergency} /> */}
                        <span>Monthly Test</span>
                    </div>
                    <img className="onoff-icon" src={monthlyTest ? btn_on1 : btn_off1} onClick={() => this.monthlyTestClick('monthlyTest')} />

                </div>

                <div className="group-header">
                    <div className="action-title">
                        {/* <img className='icon' src={emergency} /> */}
                        <span>Annual Test</span>
                    </div>
                    <img className="onoff-icon" src={annualTest ? btn_on1 : btn_off1} onClick={() => this.annualTestClick('annualTest')} />
                </div>



                <div className="line_space"></div>


                {/* 灯数据 */}
                <div className="device-header" onClick={() => { this.gotoEmergencyLightingDevice() }}  >
                    <div className="action-title">
                        <img className='icon' src={emergency} />
                        <span>Single Device Control</span>
                    </div>

                    <div className="action-group">
                        <img className="arrow-icon" src={this.state.checked ? arrow_down : arrow_right} />
                    </div>
                </div>
                <div className='devices' style={{ display: this.state.checked ? "flex" : "none" }}>
                    {this.state.devices.map((device) => (
                        <div key={device.macAddress} style={{ display: IsEmergencyDevice(device.pid) ? "flex" : "none" }} className="device_item">
                            <div className='device_left'>
                                <img className='device_icon' src={montion} />
                                <span onClick={() => { this.controlPageDetailContainer(device) }} >{device.name}</span>
                            </div>
                            <div className='device_right'>
                                <img className='device_eye' onClick={() => { this.showHightLight(device) }} src={eye_show} />
                                <img className='device_sign' src={device.online == 1 ? wifi_4 : wifi_0} />
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        );
    }
}
